import {TypedUseSelectorHook, useDispatch, useSelector} from "react-redux";
import {RootState, XDispatch} from "./index";

/**
 * Custom-typed Redux hooks ...
 * Redux recommends putting custom-typed hooks in file separate from `store/index.ts` (file where store is initialized)
 *  in order to avoid issues w/ circular dependencies and allow quick/minimal import in any other component.
 * Quote: We recommend using the pre-typed useAppSelector and useAppDispatch hooks shown above. If you prefer not
 *  to use those, here is how to type the hooks by themselves.
 *
 * @source:
 *  - https://redux-toolkit.js.org/usage/usage-with-typescript#using-the-extracted-dispatch-type-with-react-redux
 *  - https://react-redux.js.org/using-react-redux/usage-with-typescript
 *  - https://react-redux.js.org/using-react-redux/usage-with-typescript#define-typed-hooks
 */
export const useXDispatch: () => XDispatch = useDispatch
export const useXSelector: TypedUseSelectorHook<RootState> = useSelector